export default __webpack_public_path__ + "static/media/britain_flag.37c72b4c.png";